import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=6144e5ba&scoped=true&"
import script from "./panel.vue?vue&type=script&lang=ts&"
export * from "./panel.vue?vue&type=script&lang=ts&"
import style0 from "./panel.vue?vue&type=style&index=0&id=6144e5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144e5ba",
  null
  
)

export default component.exports